import { useState, useEffect, useCallback, useMemo } from 'react';
import { useTheme } from '@/contexts/ThemeContext';
import { KstDataGrid, type KstDataGridColumn, type KstDataGridRows, type KstDataGridPager } from '@/components/KstDataGrid';
import { App } from '@/services/app-compat';
import { api } from '@/services/api-class';
import moment from 'moment';

// Value lookup: access lazily at usage sites via (window as any).DATETIME_FORMAT_DISPLAY_LOCAL_MOMENT

const ornaSupportAttachmentsColumns: KstDataGridColumn[] = [
  { field: 'id', name: 'ID', size: 'hidden' },
  {
    field: 'title',
    name: 'Name / Download',
    size: 'col-xs-3',
    template: (e: any) => {
      return `<a href="${e.signedURL}" target="_blank">${e.title}</a>`;
    },
  },
  { field: 'filename', name: 'Filename', size: 'col-xs-3' },
  {
    field: 'dateCreated',
    name: 'Uploaded At',
    size: 'col-xs-3',
    template: (e: any) => {
      return moment(e.dateCreated).format((window as any).DATETIME_FORMAT_DISPLAY_LOCAL_MOMENT).toString();
    },
  },
  { field: 'createdBy', name: 'Uploaded By', size: 'col-xs-3' },
];

export function OrnaSupportAttachmentsScreen() {
  const { theme } = useTheme();

  const [entries, setEntries] = useState<any[] | null>(null);
  const [isAttachmentsLoading, setIsAttachmentsLoading] = useState<boolean>(false);

  const rows: KstDataGridRows = useMemo(() => ({ entries }), [entries]);
  const pager: KstDataGridPager = useMemo(
    () => ({ curPage: null as any, numPages: null as any, records: null as any, isVisible: false }),
    []
  );

  const refreshList = useCallback(() => {
    setIsAttachmentsLoading(true);
    api.getOrnaSupportAttachmentsList((result: any) => {
      setEntries(result.attachmentList || []);
      setIsAttachmentsLoading(false);
    }, () => {
      App.showPopupNotification('Error getting orna support attachments. Please try again.', 'error');
      setIsAttachmentsLoading(false);
    });
  }, []);

  // Load on mount
  useEffect(() => {
    refreshList();
  }, [refreshList]);

  return (
    <div className={theme}>
      <div className="kst-page-container">
        <div className="kst-layout kst-layout--no-sidebar">
          <div className="kst-main-content">
            <div className="kst-page">
              <div className="kst-page-header">
                <h3 className="kst-page-title">Orna Support Attachments</h3>
                <p className="kst-page-description">
                  Attachments for you. These are not company-wide.
                </p>
              </div>

              <KstDataGrid
                columns={ornaSupportAttachmentsColumns}
                rows={rows}
                pager={pager}
                loading={isAttachmentsLoading}
                showcheckbox={false}
                showheader={false}
                mobiletitlefield="title"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OrnaSupportAttachmentsScreen;

